const arsFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  maximumFractionDigits: 0,
});

const arsCentsFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat('es-AR');

/** Muestra centavos solo cuando existen: $625.000 · $833.333,33 */
export function formatARSCents(value: number): string {
  const hasCents = Math.round(value * 100) % 100 !== 0;
  return hasCents
    ? new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
    : arsCentsFormatter.format(value);
}

export function formatARS(value: number): string {
  return arsFormatter.format(value);
}

export function formatKm(km: number): string {
  return km === 0 ? '0 km' : `${numberFormatter.format(km)} km`;
}
